import type { Company } from '../types';

export const parseOutcomeData = (company: Partial<Company>): Company =>
  ({
    ...company,
    groups: company.groups || [],
    contractor: company.contractor || false,
    contrator: company.contractor || false,
    representatives: company.representatives || [],
  }) as Company;
